import { useParams } from 'react-router';

/** Path segments below the section, e.g. ["egz", "1"] on /gitar/egz/1. */
export function useSubPath(): string[] {
  const rest = useParams()['*'] ?? '';
  return rest.split('/').filter(Boolean);
}
